// extracted by extract-css-chunks-webpack-plugin
module.exports = {"G-night":"PJMiV","G-img-wrap":"_2zJ3k","is-irregular":"_1Gk0N"};